<template >
  <div class="card dash-card barctrl" v-if="recommend" >
    <div class="card-header dash-card-header" style="height: 20px; background: transparent; ">
      <div class="center bold" style="margin-top:1px; margin-bottom: 3px;">{{ title }}<span v-if="hasAsterisk">&nbsp;*</span></div>
    </div>
    <div class="card-body dash-card-body">
      <div style="margin:0px 4px;">
        <table class="tbl-table tbl-th tbl-tr tbl-td" style="font-size: 7pt;">
          <thead>
            <tr class="tbl-tr tbl-bg tbl-cell-s" style="font-size: 7pt;" v-bind:class="{ headerHeight : isHeaderRotated }">
              <th class="left">{{$t('Webportal.Dashboard.NPS')}}</th>
              <th style="font-size: 7pt;">{{$t('Webportal.Dashboard.Score')}}</th>
              <th v-for="(wave, index2) in recommend.SurveyWave" :key="index2">
                {{ wave.Name }}
              </th>
              <th  v-bind:class="{ headerSize : isHeaderRotated }">
                <div v-if="isHeaderRotated" style="margin-bottom: -14px;" id="rotated">{{$t('Webportal.Dashboard.NumberOfShops')}}</div>
                <div v-if="!isHeaderRotated">{{$t('Webportal.Dashboard.NumberOfShops')}}</div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="tbl-tr tbl-cell-s regular">
              <td class="left">{{proHeader}}</td>
              <td>{{ recommend.ScorePromoters }}</td>
              <td class="bc-green" v-for="(wave, index) in recommend.SurveyWave" :key="index">{{ wave.ResultPromoters }}</td>
              <td>{{ recommend.Promoters }}</td>
            </tr>
            <tr class="tbl-tr tbl-cell-s regular">
              <td class="left">{{neutralHeader}}</td>
              <td>{{ recommend.ScorePassives }}</td>
              <td class="bc-yellow" v-for="(wave, index) in recommend.SurveyWave" :key="index">{{ CalculatePassives(wave) }}</td>
              <td>{{ recommend.Passives }}</td>
            </tr>
            <tr class="tbl-tr tbl-cell-s regular">
              <td class="left">{{contraHeader}}</td>
              <td>{{ recommend.ScoreDetractors }}</td>
              <td class="bc-red" v-for="(wave, index) in recommend.SurveyWave" :key="index">{{ wave.ResultDetractors }}</td>
              <td>{{ recommend.Detractors }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr v-if="showNPS && recommend.NPSAverage" class="tbl-tr tbl-bg  tbl-cell-s bold">
              <td colspan="2" class="left">{{$t('Webportal.Dashboard.NPS')}} {{$t('Webportal.Dashboard.Average')}}:</td>
              <td class="" v-for="(wave, index) in recommend.SurveyWave" :key="index"><div style="text-align: center;">{{ wave.NPSAverage }} <span class="dotsm" v-bind:class="getBackgroundClass(recommend.NPSAverage)"></span></div></td>
              <td></td>
            </tr>
          </tfoot>
        </table>

        <div v-if="showNPS && recommend.NPSAverage" style="height: 20px; text-align: center; margin-top: 0.5rem;" class="bold">{{$t('Webportal.Dashboard.NPS')}} {{$t('Webportal.Dashboard.Average')}} {{$t('Webportal.Dashboard.Overall')}}: {{ recommend.NPSAverage }}
          <span class="dot" v-bind:class="getBackgroundClass(recommend.NPSAverage)"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'RecommendationTable',

    props:[
      'hasAsterisk',
      'recommend',
      'isCompetitionOverall',
      'proHeader',
      'contraHeader',
      'neutralHeader',
      'title',
      'isHeaderRotated',
      'showNPS'
    ],

    methods: {
      getBackgroundClass(num) {
        if (num < 6.5) { return 'bc-red';}
        if (num < 8.5) { return 'bc-yellow';}
        return 'bc-green';
      },

      CalculatePassives(wave)  {
        let sum = wave.ResultPromoters + wave.ResultPassives + wave.ResultDetractors;
        if (sum === 100) return wave.ResultPassives;
        return 100 - wave.ResultPromoters - wave.ResultDetractors;
      }
    }
  }
</script>


<style scoped>
.rec_card_body{
    margin: 2px;
    padding: 0px;
    width: 100%;
}
.dot {
  height: 12px;
  width: 12px;
  border-radius: 50%;
  display: inline-block;
}
.dotsm{
  height: 8px;
  width: 8px;
  border-radius: 50%;
  display: inline-block;
}
.head10 {
  width:10%;
}
.head40 {
  width:40%;
}

#nsc {
  float: right;
  line-height: 1.1
}

.home {
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
  background: transparent;
}

#rotated {
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    -o-transform: rotate(-90deg);
    -ms-transform: rotate(-90deg);
    transform: rotate(-90deg);
}

.headerHeight {
  height: 16mm;
}

.headerSize {
  max-width: 14px;
}
</style>
